import React, { FC } from 'react'
import Tooltip from '../../../Molecules/Tooltip/Tooltip'
import Icon from '../../Iconography/Icon/Icon'
import Flex from '../../../Layout/Flex/Flex'

import { FontStyle } from './Font.styles'

import { FontProps } from './types'

const Font: FC<FontProps> = props => {
  const {
    tag,
    tooltipLabel,
    lineHeight,
    width,
    tooltipPosition,
    display,
    whiteSpace,
    tooltipWidth
  } = props

  const isBold: boolean = props.bold || (tag && ['h4'].includes(tag)) || false
  const isMiller: boolean = (tag && ['h1', 'h2', 'h3'].includes(tag)) || props.isMiller || false

  return (
    <FontStyle
      as={tag}
      bold={isBold}
      isMiller={isMiller}
      oneLine={props.oneLine}
      ellipsis={props.ellipsis}
      smallest={props.smallest}
      toUpperCase={props.toUpperCase}
      tag={tag}
      color={props.color}
      margin={props.margin}
      padding={props.padding}
      textAlign={props.textAlign}
      gridArea={props.gridArea}
      bgColor={props.bgColor}
      border={props.border}
      tooltipLabel={tooltipLabel}
      lineHeight={lineHeight}
      width={width}
      display={display}
      minHeight={props.minHeight}
      whiteSpace={whiteSpace}
      multiLineEllipsis={props.multiLineEllipsis}
      onClick={props?.onClick ? props?.onClick : null}
      title={
        props?.ellipsis && props?.showTitle ? (props?.children as string) : ''
      }
    >
      {props.children}
      {tooltipLabel && (
        <Flex alignItems='flex-start'>
          <Tooltip tooltipText={tooltipLabel} translateY={-6} position={tooltipPosition} width={tooltipWidth}>
            <Icon name='info' size='xs' color='ultraViolet' hoverColor />
          </Tooltip>
        </Flex>
      )}
    </FontStyle>
  )
}

Font.defaultProps = {
  bold: false,
  isMiller: false,
  oneLine: false,
  ellipsis: false,
  smallest: false,
  tag: 'p',
  color: 'dark',
  children: '',
  gridArea: '',
  tooltipLabel: '',
  width: ''
}

export default Font
